import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
import RenditionsFields from './formGroup23OutputRenditionsFields';
import CamerasFields from './formGroup21OutputCamerasFields';
import ViewportFields from './formGroup25OutputViewportFields';
import { yearsToMonths } from 'date-fns';

export default {
  title: 'Output configuration',
  attributeName: 'videoOutput',
  validationUrl:'live',
  hiddenJsonComponent:true,
  fields: [
    {
      attributeName: 'uniqueId',
      label: 'UNIQUEID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'parentUID',
      label: 'PARENTUID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'type',
      label: 'Type',
      helpText: 'Type of the ingest server.',
      type: FormInputTypes.SELECT,
      default:'180',
      disabledWhenEdit:true,
      options: [
        { name: '180', value: '180' },
        { name: '360', value: '360' },
        { name: 'Flat', value: 'flat' },
        { name: 'Control room', value: 'controlroom' },
        { name: 'CCR', value: 'ccr' }
      ],
    },
    {
      attributeName: 'stereoMode',
      label: 'Stereo mode',
      helpText: 'Type Stereo mode.',
      type: FormInputTypes.SELECT,
      default:'MONO',
      options: [
        { name: 'Mono', value: 'MONO' },
        { name: 'Stereo', value: 'STEREO' },
      ],
    },
    {
      attributeName: 'geometry180',
      label: 'In Geometry',
      helpText: 'Type geometry.',
      type: FormInputTypes.SELECT,
      default:'equidome',
      options: [
        { name: 'Equidome', value: 'equidome' },
        { name: 'Fisheye', value: 'fisheye' },
      ],
      visibleWhen: [{field: 'type', value: '180'},{"field":"deploymentType","value":"lowLatency"}],

    },
    {
      attributeName: 'kDistortionCoefficients',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'enter the k distortion Coefficients',
      label: 'Distortion Coefficients - K',
      default: '',
      visibleWhen: [{field: 'geometry180', value: 'fisheye'},{"field":"deploymentType","value":"lowLatency"}],
      required: true,
      helpText: 'Enter the format, only needed for K Distortion Coefficients.',
      errorText: '',
    },
    {
      attributeName: 'dDistortionCoefficients',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'enter the d distortion Coefficients',
      label: 'Distortion Coefficients - D',
      default: '',
      visibleWhen: [{field: 'geometry180', value: 'fisheye'},{"field":"deploymentType","value":"lowLatency"}],
      required: true,
      helpText: 'Enter the format, only needed for D Distortion Coefficients.',
      errorText: '',
    },
    {
      attributeName: 'stereoType',
      label: 'Stereo type',
      helpText: 'Stereo type.',
      type: FormInputTypes.SELECT,
      default:'TB',
      options: [
        { name: 'Top Bottom', value: 'TB' },
        { name: 'Left Right', value: 'LR' },
      ],
      visibleWhen:[{"field":"stereoMode","value":"STEREO"}],
    },
    {
      attributeName: 'inGeometry', //only in 360 videos
      type: FormInputTypes.SELECT,
      label: 'In Geometry',
      visibleWhen:[{"field":"type","value":"360"},{"field":"deploymentType","value":"ott"}],
      helpText: 'Set the In Geometry.',
      default:'equirect',
      options: [
        { name: 'equirect', value: 'equirect' },
      ],
      errorText: '',
    },
    {
      attributeName: 'geometry360', //only in 360 videos
      type: FormInputTypes.SELECT,
      label: 'Geometry',
      visibleWhen:[{"field":"type","value":"360"},{"field":"deploymentType","value":"lowLatency"}],
      helpText: 'Set the In Geometry.',
      default:'equirect',
      options: [
        { name: 'Equirect', value: 'equirect' },
        { name: 'AP3', value: 'AP3' },
        // { name: 'CM32',value:'CM32'} //removed by STREAM-10456
      ],
      errorText: '',
    },

    {
      attributeName: 'geometryCR', //only in 360 videos
      type: FormInputTypes.SELECT,
      label: 'Geometry',
      visibleWhen:[{"field":"type","value":"controlroom"},{"field":"deploymentType","value":"lowLatency"}],
      helpText: 'Set the In Geometry.',
      default:'croomv2',
      options: [
        { name: 'croomv2', value: 'croomv2' },
      ],
      errorText: '',
    },
    { 
      attributeName: 'outerPadding', // # Only needed for Decklink sources
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'enter the decklink pixel format',
      label: 'Outer padding',
      default:'16',
      visibleWhen:[{"field":"type","value":"ccr"}],
      required: true,
      helpText: 'Enter the number in (px) you want.',
      errorText: '',
    },
    {
      attributeName: 'quality',
      type: FormInputTypes.SELECT,
      default:'FHD',
      options: [
        { name: 'FHD (1920px main, 468px miniatures, 16px inner padding)', value: 'FHD' },
        { name: 'HD (1280px main, 314px miniatures, 8px inner padding)', value: 'HD' },
        { name: 'SD (720px main, 174px miniatures, 8px inner padding)', value: 'SD' }
      ],
      label: 'Quality',
      helpText: 'Size of the mainscreen and the miniatures of the ccr.',
      errorText: '',
      visibleWhen:[{"field":"type","value":"ccr"}],

    },
    
    {
      attributeName: 'safetyBitrate', //only in 360 videos
      type: FormInputTypes.SELECT,
      label: 'Safety bitrate',
      visibleWhen:[{"field":"type","value":"360"},{"field":"deploymentType","value":"ott"}],
      helpText: 'Set the Safety bitrate.',
      options: [
        { name: '6000', value: '6000' },
      ],
      default:'6000',
      errorText: '',
    },
    {
      attributeName: 'HLSViewport',
      label: 'HLS Viewport',
      helpText: 'Type HLS viewport.',
      visibleWhen:[{"field":"type","value":"360"},{"field":"deploymentType","value":"ott"}],

      type: FormInputTypes.SELECT,
      default:'front',
      options: [
        { name: 'Front', value: 'front' },
        { name: 'Back', value: 'back' },
        { name: 'Right', value: 'right' },
        { name: 'Left', value: 'left' },
      ],
    },
    {
      attributeName: 'renditions',
      type: FormInputTypes.JSON_COMPONENT,
      emptyMessage: "You don't have any rendition yet.",
      columns:4,
      label: 'Renditions',
      itemLabel:'Rendition',
      required: true,
      helpText: 'Insert new renditions clicking in + button.',
      errorText: '',
      extraValues:['deploymentType'],
      classCss:'jsonComponent__width100',
      popupFormGroups:[
        RenditionsFields

      ]
    },
    {
      attributeName: 'cameras',
      type: FormInputTypes.JSON_COMPONENT,
      canCreate:false,
      emptyMessage: "You don't have any camera yet.",
      columns:1,
      label: 'Cameras',
      itemLabel:'Cameras',
      required: true,
      helpText: 'Insert new cameras clicking in + button.',
      errorText: '',
      extraValues:['deploymentType'],
      classCss:'jsonComponent__width100',
      popupFormGroups:[
        CamerasFields

      ]
    },
    {
      attributeName: 'viewports',
      type: FormInputTypes.JSON_COMPONENT,
      emptyMessage: "You don't have any viewport yet.",
      columns:4,
      label: 'Viewports',
      itemLabel:'Viewport',
      visibleWhen:{"field":"type","value":"360"},
      hideIfEmpty:true,
      required: true,
      helpText: 'Insert new viewport for 360.',
      errorText: '',
      extraValues:['deploymentType'],
      canRemove:false,
      canCreate:false,
      popupFormGroups:[
        ViewportFields

      ]
    },
  ]
};
